import React from 'react'
import { List, ListItemButton, ListItemText } from '@mui/material';

function CashJobType({CashJob, handleToggle}) {
  return (
    <List>
      {CashJob.map(item => (
        <ListItemButton sx={{height: '19px'}} key={item.id} onClick={()=> {handleToggle(item.id, item)}}>
          <ListItemText primary={item.label} />
        </ListItemButton>
      ))}
    </List>
  )
}

export default CashJobType